import { faRectanglePro } from '@fortawesome/pro-solid-svg-icons';
import { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Text16 } from '@sorare/core/src/atoms/typography';
import Switch from '@sorare/core/src/components/search/Switch';
import useLoggedCallback from '@sorare/core/src/hooks/useLoggedCallback';
import useVirtualToggle from '@sorare/core/src/hooks/useVirtualToggle';
import { useVirtualToggleManager } from '@sorare/core/src/hooks/useVirtualToggleManager';
import useEvents from '@sorare/core/src/lib/events/useEvents';
import {
  FilterWidget,
  VIRTUAL_TOGGLE_FILTERS,
} from '@sorare/core/src/lib/filters';

const FILTER = VIRTUAL_TOGGLE_FILTERS.notInLineupFilter;

const IconWrapper = styled.span`
  min-width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Filter = () => {
  const { formatMessage } = useIntl();
  const track = useEvents();
  const setVirtualToggle = useVirtualToggleManager();
  const { currentRefinement } = useVirtualToggle<boolean>({
    name: FILTER.name,
  });

  const loggedHandleChange = useLoggedCallback<ChangeEvent<HTMLInputElement>>(
    event => {
      const newValue = event.target.checked;
      setVirtualToggle({
        [FILTER.name]: newValue,
      });
      track('Use Market Filter', {
        filterName: FILTER.trackingName,
        filterValue: newValue.toString(),
      });
    }
  );

  return (
    <Horizontal>
      <IconWrapper>
        <FontAwesomeIcon icon={faRectanglePro} />
      </IconWrapper>
      <Switch
        checked={!!currentRefinement}
        onChange={loggedHandleChange}
        label={<Text16 bold>{formatMessage(FILTER.label!)}</Text16>}
      />
    </Horizontal>
  );
};

const widget: FilterWidget = {
  key: FILTER.name,
  type: 'virtualToggle',
  filter: FILTER,
  Component: Filter,
};

export default widget;
